import { Pulse } from "../pulse";
import { TableCell } from "./table-cell";
import { TableRow } from "./table-row";

type TableSkeletonProps = {
  numRows: number;
  columnsLength: number;
};

export const TableSkeleton = ({ columnsLength, numRows }: TableSkeletonProps) => {
  return Array.from({ length: numRows }, (_, index) => {
    return (
      <TableRow key={index}>
        {Array.from({ length: columnsLength }, (_, idx) => {
          return (
            <TableCell key={idx}>
              {/*
                The bar is thinner than a line of text, so it needs a container of
                line height: without it a skeleton row is 9px shorter than the row
                it stands in for and the table shifts as the data lands.
              */}
              <Pulse className="w-1/2" containerClassName="flex h-5 items-center" />
            </TableCell>
          );
        })}
      </TableRow>
    );
  });
};
